import React, {FC, useEffect, useState} from "react";
import {CircularProgress, Paper, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {Box} from "@mui/system";
import DoneIcon from '@mui/icons-material/Done';

interface Props {
  saving: boolean,
  resendEvent: () => void
}

export const SavingResultsComponent: FC<Props> = ({saving, resendEvent}) => {
  const [connectionIssue, setConnectionIssue] = useState(false)
  const [showSaving, setShowSaving] = useState(false)
  useEffect(() => {
    setConnectionIssue(false)
    if (saving && showSaving) {
      const timeout = setTimeout(() => {
        setConnectionIssue(true)
      }, 4500)
      return () => clearTimeout(timeout)
    }
  }, [saving, showSaving])

  useEffect(() => {
    if (saving) {
      setShowSaving(true)
    } else {
      const timeout = setTimeout(() => {
        setShowSaving(false)
      }, 500)
      return () => clearTimeout(timeout)
    }
  }, [saving])
  const {t} = useTranslation()
  return <Box alignItems={'center'} justifyContent={'center'} display={'flex'} flexDirection={'column'} width={'100%'}
              sx={{minHeight: 50}}>
    <Paper elevation={3} sx={{paddingY: 2, width: '100%'}} onClick={resendEvent}>
      {connectionIssue && saving && <Typography align={"center"} color={"red"}>{t('event.savingIssue')}</Typography>}
      {showSaving && <Box alignItems={'center'} justifyContent={'center'} display={'flex'} gap={2}>
          <Typography> {t('event.saving')} </Typography>
          <CircularProgress size={25}/>
      </Box>}
      {!showSaving && <Box alignItems={'center'} justifyContent={'center'} display={'flex'} gap={2} color={'#2e7d32'}>
          <Typography align={'center'} variant={'button'}>{t('event.resultsAreSynced')}</Typography>
          <DoneIcon/>
      </Box>}
    </Paper>

  </Box>

}